module.exports = __webpack_public_path__ + "static/media/headshot.530bfbc3.jpg";